import React, { useState, useEffect, useContext } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Typography, IconButton, Container, Paper, Stack, Box, Backdrop, CircularProgress, useMediaQuery, useTheme, Button, Dialog, TextField, Divider } from '@mui/material';
import { API } from '../conf';
import { Context } from '../App';
import {FolderOpenRounded, PrintOutlined, Download} from '@mui/icons-material';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const FileViewer = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [user, setUser] = useState(JSON.parse(sessionStorage.getItem('user')))
    const { setIsConnected } = useContext(Context)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [open, setOpen] = useState(false);
    const [tel, setTel] = useState(user?.tel??'')
    const [inscrits, setInscrits] = useState(0)

    useEffect(() => {
        fetch(API.concat(`/directory`), {
            method:'GET',
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                setIsConnected(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const data = await response.json();
                    setFiles(data)
                } else {
                    const text = await response.text();
                    setError(text);
                }
                setLoading(false);
            }
        }).catch(error => console.error('Error fetching files:', error));

        fetch(API.concat(`/Delegue/by/${JSON.stringify({transport: true})}/count`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status > 400) {
                sessionStorage.clear()
                setIsConnected(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setInscrits(json);
                }
            }
        }).catch(error => console.error('Error get inscrits:', error));
    }, [setIsConnected]);

    async function getFile(file) {
        setError()
        return new Promise((resolve, reject)=>{
            fetch(API.concat(`/files/${file.replace('/',';')}`), {
                method:'GET',
                headers: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status > 400) {
                    sessionStorage.clear()
                    setIsConnected(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        const url = URL.createObjectURL(blob)
                        resolve(url)
                    } else {
                        const text = await response.text();
                        setError(text??'Error fetching file');
                        resolve()
                    }
                }
            }).catch(error => console.error('Error fetching files:', error));
        })
    };

    const handleFileClick = (file) => {
        setLoading(true); 
        getFile(file).then(pdf_url=>{
            if (pdf_url) {
                setSelectedFile(pdf_url)
            }
            setLoading(false)
        })
    };

    function print(file) {
        setLoading(true)
        getFile(file).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = () => win.print();
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoading(false)
        })
    }

    function download(file) {
        setLoading(true)
        getFile(file).then(pdf_url=>{
            const a = document.createElement('a');
            a.href = pdf_url;
            a.download = file;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setLoading(false)
        })
    }

    function handleInscription() {
        setOpen(false); setLoading(true); setError()
        if(!user) {sessionStorage.clear(); setIsConnected(false); return}
        fetch(API.concat(`/inscriptions/bus/${user._id}`), {
            method:'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({tel})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status > 400) {
                sessionStorage.clear()
                setIsConnected(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                } if(response.status===200){
                    const json = await response.json()
                    sessionStorage.setItem('user', JSON.stringify(json))
                    setUser(json)
                } else {
                    const text = await response.text();
                    setError(text);
                    setTimeout(() => {
                        setError()
                    }, 10000);
                }
                setLoading(false);
            }
        }).catch(error => console.error('Error fetching files:', error));
    }

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Container sx={{display:'flex', flexDirection:'column'}}>
            <Stack direction="row" alignItems='center' spacing={2} style={{ marginBlock: '20px' }}>
                <img src="/logo.png" alt="logo" width={isMobile?"60":"100"} height={isMobile?"60":"100"} />
                <Box>
                    <Typography variant={"h3"} sx={{fontSize:isMobile?17:24, fontWeight:'bold'}} textTransform='uppercase'>
                        église adventiste du 7ème jour
                    </Typography>
                    <Typography variant="h5" sx={{fontSize:isMobile?14:20}} textTransform='uppercase'>
                        Assemblée Générale Fédération Martinique
                    </Typography>
                </Box>
            </Stack>
            {(user.transport||inscrits<28)&&<Box display={'flex'} flexDirection={'column'} justifySelf={'end'} alignItems={'center'} style={{marginBlock:'20px'}}>
                <Button variant='contained' sx={{alignSelf:'en</Box>d'}} onClick={()=>setOpen(true)}>Inscription transport</Button>
                <Typography textAlign='center'>Date limite d'inscription <span style={{color:'red', fontWeight:'bold'}}>vendredi 31 janvier 2025</span><br/>Places limitées à 35 personnes<br/>
                Places restantes: <span style={{color:'green', fontWeight:'bold'}}>{28-inscrits}</span></Typography>
            </Box>}
            <Typography variant="h4" sx={{marginLeft:'100px', paddingLeft:2}} gutterBottom>
                Documents
            </Typography>

            {error && <Typography variant='h6' color='error'>{error}</Typography>}

            <Paper>
                {files.filter(file=>typeof file === 'object').map((folder, index) => (folder.files.length>0&&<Box display='flex' flexDirection='column' marginLeft={5} key={index}>
                    <Divider orientation='horizontal' variant='middle' sx={{marginRight:2, alignSelf:'center', width:'70%', fontSize:isMobile?14:20, fontWeight:'bold', textTransform:'uppercase'}}>{folder.dir}</Divider>
                    <List key={index}>
                        {folder.files.map(file => (
                            <ListItem button key={file} onClick={() => handleFileClick(`${folder.dir}/${file}`)}
                            secondaryAction={
                                <Stack direction='row' spacing={2}>
                                    <IconButton edge="end" aria-label="download" sx={{marginRight:2}} onClick={()=>download(`${folder.dir}/${file}`)}>
                                        <Download/>
                                    </IconButton>
                                    {!isMobile&&<IconButton edge="end" aria-label="delete" sx={{marginRight:2}} onClick={()=>print(`${folder.dir}/${file}`)}>
                                    <PrintOutlined/>
                                    </IconButton>}
                                </Stack>
                            }>
                                <ListItemIcon>
                                    <FolderOpenRounded fontSize="large" />
                                </ListItemIcon>
                                <ListItemText slotProps={{primary:{fontSize:22}}} primary={file.replace('.pdf','')} />
                            </ListItem>
                        ))}
                    </List>
                </Box>))}
            </Paper>
            {selectedFile && (
                <Paper style={{ marginBlock: '20px', padding: '10px' }}>
                    {isMobile?<Viewer fileUrl={selectedFile} />
                    :<iframe src={selectedFile} width="100%" height="600px" title="File Viewer" />}
                </Paper>
            )}

            <Backdrop open={loading}><CircularProgress/></Backdrop>

            <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='sm' fullWidth>
                <Box component='form' onSubmit={handleInscription} display='flex' flexDirection='column' padding='20px' justifyContent={'center'} alignItems={'center'}>
                    <Typography variant='h5' gutterBottom>Inscription transport</Typography>
                    <Typography variant='body1' textAlign='center' gutterBottom>La FEAM met à disposition des délégués et du personnel un bus qui partira le samedi 1 février 2025 à 8h15 du siège de la FEAM.<br/>
                        Veuillez renseigner votre numéro de téléphone afin de vous inscrire.</Typography>
                    <TextField label='Téléphone' value={tel} onChange={e=>setTel(e.target.value)} />
                    <Stack direction='row' spacing={2} alignItems='center' marginTop={2}>
                        <Button variant='contained' type='submit' disabled={tel.length<(tel.charAt(0)==='0'?10:9)||(user.transport&&user.tel===tel)} sx={{marginTop:'20px'}}>{user.transport?'Mettre à jour mon inscription':"M'inscrire"}</Button>
                        {user.transport&&<Button variant='contained' type='submit' disabled={tel.length<(tel.charAt(0)==='0'?10:9)} sx={{marginTop:'20px'}}>Annuler mon inscription</Button>}
                    </Stack>
                </Box>
            </Dialog>
            
        </Container>
        </Worker>
    );
};

export default FileViewer;